import { render } from "./UserRecordsData.vue?vue&type=template&id=19996ec9&scoped=true"
import script from "./UserRecordsData.vue?vue&type=script&lang=js"
export * from "./UserRecordsData.vue?vue&type=script&lang=js"

import "./UserRecordsData.vue?vue&type=style&index=0&id=19996ec9&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19996ec9"]])

export default __exports__